import React, { Component } from 'react'
import { Map, List, fromJS } from 'immutable'
import { Icon } from 'semantic-ui-react'
import Api from '~/api'

export default class CopyAndArchive extends Component {
  state = {
    loading: false,
  }

  handleCopy = () => {
    let { loading } = this.state
    let { updateMaterials, materials, id } = this.props

    if (loading) return

    this.setState({ loading: true })

    Api.post(`/article/${id}/clone`, { id })
      .then(({ data }) => {
        if (!data.success) throw Error(data.message || 'Error when copying article')

        let article = data.item

        article.type = 'article'

        let material = {
          id: article.id,
          type: 'article',
          archived: false,
          file: article,
        }

        materials = materials.map(m => (m.get('id') === id ? m.set('archived', true) : m)).push(fromJS(material))

        let events = [
          {
            type: 'INTERVIEW_COPY_ARTICLE',
            variables: {
              title: article.title,
            },
          },
        ]

        this.setState({ loading: false })
        updateMaterials(materials, events)
      })
      .catch(err => alert(err.message))
  }

  render() {
    let { loading } = this.state
    return (
      <button className="material-copy-article" onClick={e => e.preventDefault() & this.handleCopy()}>
        <Icon name={loading ? 'spinner' : 'copy'} loading={loading} /> Arkistoi ja luo kopio
      </button>
    )
  }
}
